<template>
  <div class="confirm" v-loading="submitLoading">
    <div class="header" v-if="!(mixScene || hideSideMenu)">
      <img src="@/assets/common/logo-black.svg" style="width: 71px; height: 20px" />
      <p>
        <span>{{ userInfo.name | formatName }}</span>
        <span @click="goOut" v-if="!$route.query.client">| {{ $t('退出') }}</span>
      </p>
    </div>
    <div class="info">
      <img src="@/assets/common/ht.png" />
      <div>
        <p>
          <span>{{ packageInfo.packageName || packageInfo.commodityName }}</span>
          <span>￥{{ packageInfo.price }}</span>
        </p>
        <p>
          <span v-if="saleType == 1">{{ packageInfo.commodityName }}{{ packageInfo.totalNum }}{{ packageInfo.units }}，</span>
          <span v-if="saleType == 1">
            {{
              $t('有效期{year}年', {
                year: packageInfo.effectiveDate,
              })
            }}
          </span>
          <span v-if="saleType == 2">{{ $t('有效期无限') }}</span>
        </p>
      </div>
    </div>
    <div class="diacount" v-if="saleType !== 2">
      <p>{{ $t('购买份数') }}</p>
      <p>
        <es-input-number
          :key="inputkey"
          v-model="num"
          controls-position="right"
          :disabled="banNumContral"
          @change="handleChange"
          :min="1"
          :max="99999"></es-input-number>
      </p>
    </div>
    <div class="common-price">
      <p>{{ $t('商品标准价格') }}</p>
      <p>
        <span>{{ packageInfo.price || packageInfo.price === 0 ? packageInfo.price * num.toFixed(2) : '-' }}</span>
      </p>
    </div>
    <div class="ticket" v-if="promotionDisplay">
      <p>{{ $t('优惠券') }}</p>
      <p v-if="!isChangeStatus">
        <span @click="checkCoupons()">{{ $t('有可用优惠券') }}<i class="es-icon-arrow-right"></i></span>
      </p>
      <p v-else>
        <span @click="showCoupons()">&nbsp;{{ $t('已输入优惠券') }}&nbsp;</span>
        <i class="el-icon-remove" @click="clearCoupons()"></i>
      </p>
    </div>
    <div class="discount-price" v-if="discounted !== 0">
      <p>{{ $t('已优惠') }}</p>
      <p>
        <span class="last-child">-{{ discounted.toFixed(2) }}</span>
      </p>
    </div>

    <div class="diacount">
      <p>{{ $t('实际支付金额') }}</p>
      <p>
        <span v-show="saleOff" class="first-child">{{ saleOff }}</span>
        <span class="last-child">{{
          packageInfo.price || packageInfo.price === 0 ? returnSaleMoney(packageInfo.price) : '-'
        }}</span>
      </p>
    </div>

    <div class="time" @click="openPicker()" v-show="productType != 2">
      <p>{{ $t('订单生效时间') }}</p>
      <p :class="{ disabledText: disableTimeChange }">
        <span>{{ pickerValue | formatUtc('day') }}</span>
        <span style="margin-left: 10px; color: #cccf">></span>
      </p>
    </div>
    <div class="tip" v-show="productType != 2 && !disableTimeChange">
      {{ $t('您可以设置订单开始生效时间，即以此时间开始方可使用相关服务。') }}
    </div>
    <div class="confirm-agree">
      <es-checkbox v-model="checked">{{ $t('我已阅读，同意此协议') }}</es-checkbox>
      <span class="confirm-agree-btn" @click="viewCert">{{ $t('点此查看协议') }}</span>
    </div>
    <div :class="['footer']">
      <em-button @click="submit" :class="['button', { disabled: !checked }]" :loading="submitLoading" size="huge" square>
        {{ $t('提交订单') }}&nbsp;￥{{ returnSaleMoney(packageInfo.price) }}
      </em-button>
    </div>
    <DatetimePicker
      ref="picker"
      type="date"
      :startDate="new Date()"
      :year-format="$t(`{value} 年`)"
      :month-format="$t(`{value} 月`)"
      :date-format="$t(`{value} 日`)"
      @confirm="handleConfirm"></DatetimePicker>
    <Actionsheet :actions="actions" v-model="sheetVisible"></Actionsheet>
    <mt-popup v-model="popupVisible" position="bottom">
      <div class="popup-head">
        <i class="es-icon-arrow-left" @click="popupVisible = false"></i>{{ $t('请输入签署密码') }}
      </div>
      <div class="popup-body">
        <es-input :placeholder="$t(`请输入签署密码进行支付`)" v-model="password" type="password"></es-input>
        <es-button @click="sure" type="danger" :disabled="!password">{{ $t('确定') }}</es-button>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import { $t } from '@/locales'

/* eslint-disable */
import MD5 from 'js-md5'
import { mapState } from 'vuex'
import { DatetimePicker, Actionsheet, Popup, MessageBox, Toast } from 'mint-ui'
import tsignDataTrack from '@tsign/tsigndata-sdk-js'
import { compareVersion, detectAliMini } from '../../util'
import 'mint-ui/lib/style.css'
import { orderSourceMap } from '@esign/esign-client-jssdk'
// ALIPAY("ALI_PAY", "e签宝支付宝生活号"),

// QY_WECHAT("QY_WECHAT", "e签宝企业微信"),
// H5("H5", "e签宝电子合同h5"),
// WEB("WEB", "e签宝电子合同web"),
// DING_TALK("DING_TALK", "钉签微应用"),
// APP_IOS_SCENE("APP_IOS_SCENE", "iOS现场签app"),

//
export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
      tsignData: state => state.tsignData,
      hideSideMenu: state => state.hideSideMenu,
      mixScene: state => state.mixScene
    }),
    // 版本号大于3.8.2的易签宝App显示微信支付
    // 支付宝小程序和其他版本app不展示
    showWeChatPay () {
      const { client } = this.$route.query

      return (
        ((client == 'APP_ANDROID' || client == 'APP_IOS') && compareVersion(this.$esignClientVersion, '3.8.2') >= 0) ||
        !(this.isAliPay || client == 'APP_ANDROID' || client == 'APP_IOS')
      )
    },
    isAliPay () {
      // client携带包含ALI_PAY_MINI的标识代表支付支付, 目前有：ALI_PAY_MINI（e签宝合同管理小程序）、ALI_PAY_MINI_BID（e签盾小程序）
      return this.$route.query.client && this.$route.query.client.includes('ALI_PAY_MINI')
    },
    // 是否e签盾安卓app
    isEqdAndroidApp () {
      return ['EQD_APP_ANDROID', 'EQB_APP_ANDROID'].includes(this.$route.query.client)
    },
    // 是否e签宝iosapp
    isEqdIosApp () {
      return ['EQD_APP_IOS', 'EQB_APP_IOS'].includes(this.$route.query.client)
    },
    // 是否安卓app (e签宝、e签盾)
    isAndroidApp () {
      return ['APP_ANDROID'].includes(this.$route.query.client)
    },
    // 是否ios app (e签宝、e签盾)
    isIosApp () {
      return ['APP_IOS'].includes(this.$route.query.client)
    }
  },
  components: {
    DatetimePicker,
    Actionsheet,
    Popup
  },
  data () {
    return {
      isPageHide: false,
      inputkey: 0,
      loading: '',
      banNumContral: false,
      commodityName: '',
      submitLoading: false,
      productType: '',
      num: this.$route.query.num || 1,
      saleType: '',
      exeTotalNum: '',
      extPrice: '',
      pdfUrl: '',
      checked: false,
      password: '',
      sheetVisible: false,
      popupVisible: false,
      actions: [],
      pickerValue: +new Date(),
      packageInfo: {},
      saleOff: '',
      discountType: '',
      discountAmount: '',
      discountPrice: '',
      discounted: 0,
      commodityNo: '',
      promotionDisplay: false,
      sourceChannel: Number(sessionStorage.getItem('source_channel')) || 0,
      couponsNumber: '', // 优惠码
      realCouponsNumber: '',
      isChangeStatus: false,

      billingProductId: '',
      orderId: '',
      activeNo: '',
      myWallet: '',
      clock: null,
      disableTimeChange: parseInt(this.$route.query.source_channel) === 9,
      isAliPayMini: false, // 是否支付宝小程序
      orderDetail: {}
    }
  },
  methods: {
    reportSourceChannel (type, orderId = '-') {
      const personOid = localStorage.getItem('ouid')
      const personGid = localStorage.getItem('guid')
      const data = {
        commodity_number: this.packageInfo.totalNum * this.num,
        commodity_name: this.commodityName || `h5error-saleType:${this.saleType}`,
        commodity_id: this.$route.query.commodityId,
        user_type: this.isOrg ? '企业' : '个人',
        oid: this.isOrg ? this.userInfo.orgId : personOid,
        gid: this.isOrg ? this.userInfo.gid : personGid,
        pay_amount: this.returnSaleMoney(this.packageInfo.price),
        geren_oid: personOid,
        geren_gid: personGid,
        order_source: orderSourceMap[this.sourceChannel] || 'other',
        order_id: orderId
      }
      tsignDataTrack.track(type, data)
    },
    // 再次输入优惠券
    showCoupons () {
      this.checkCoupons()
    },
    // 清除已输入的优惠券
    clearCoupons () {
      MessageBox.confirm($t('是否删除当前优惠券信息？')).then(action => {
        this.realCouponsNumber = this.couponsNumber = ''
        this.getExecRule(this.packageInfo.totalNum * this.num, this.packageInfo.price * this.num)
      })
    },
    // 使用优惠券
    checkCoupons () {
      const messageStr = this.isChangeStatus ? $t('再次确认后将替换之前的优惠') : ' '
      MessageBox.prompt(messageStr, $t('优惠码'), {
        inputPlaceholder: $t('请输入优惠券编号'),
        inputValue: this.realCouponsNumber
      })
        .then(({ value, action }) => {
          if (action === 'confirm') {
            this.couponsNumber = value
            this.getExecRule(this.packageInfo.totalNum * this.num, this.packageInfo.price * this.num)
          }
        })
        .catch(() => { })
    },
    getPromoInfo (channelGid) {
      this.$ajax(this.$url.getPromo(), { channelGid }).then(res => {
        this.promotionDisplay = res.data
        this.getCommodity()
      })
    },
    weixinPay () {
      const { client, openId } = this.$route.query
      const url = localStorage.getItem('returnUrl') || ''
      const isContainParams = url.indexOf('?') === -1
      const returnUrl = `${url}${isContainParams ? '?' : '&'}orderId=${this.orderId}`

      if (client === 'WE_CHAT' || client === 'WE_CHAT_BOSS' || client === 'WE_CHAT_ZQB') {
        // 如果是小程序
        // 招签宝平台单独处理
        const preNav = client === 'WE_CHAT_ZQB' ? '/pages/h5-route/index' : '/pages/h5-route'
        // 创建小程序支付单
        this.createAppletPay({ openId, returnUrl, thirdPayMode: 'TENPAY' }).then(prepayId => {
          this.reportSourceChannel('order_pay_success', this.orderDetail.showId)
          // e签盾销毁当前webview，其他场景保持不变
          ;(client === 'WE_CHAT_ZQB' ? wx.miniProgram.redirectTo : wx.miniProgram.navigateTo)({
            url: `${preNav}?type=wechatPay&prepay_id=${prepayId}&redirectUrl=${encodeURIComponent(returnUrl)}`
          })
        })
      } else if (navigator.userAgent.indexOf('MicroMessenger') > 0 && client === 'WE_CHAT_WEB') {
        //如果是微信内置浏览器支付
        this.createAppletPay({ openId: this.openId, returnUrl, thirdPayMode: 'TENPAY' }).then(prepayId => {
          // 获取prepayId
          this.$ajax(this.$url.wechatPay(), { client, openId: this.openId, prepayId }).then(res => {
            WeixinJSBridge.invoke('getBrandWCPayRequest', { package: res.data.packageStr, ...res.data }, res => {
              this.reportSourceChannel('order_pay_success', this.orderDetail.showId)
              // res.err_msg将在用户支付成功后返回ok，微信不保证它绝对可靠。成功跳转到结果页
              if (res.err_msg === 'get_brand_wcpay_request:ok') {
                console.log(localStorage.getItem('returnUrl'))
                console.log(this.getReturnUrl('isWxPay'))
                window.location.href = decodeURIComponent(this.getReturnUrl('isWxPay'))
              } else {
                //支付失败 重新跳转至支付页
                window.location.href = sessionStorage.getItem('confirmUrl')
              }
            })
          })
        })
      } else {
        const ISANDROID = this.$route.query.client === 'APP_ANDROID'
        const ISIOS = this.$route.query.client === 'APP_IOS'
        //H5支付不能在微信内浏览器支付  后端获取微信支付收银台的中间页面URL 获取成功后跳转支付
        this.$ajax(this.$url.weixinPay(this.payOrderId), ISANDROID ? {} : { returnUrl }).then(res => {
          this.reportSourceChannel('order_pay_success', this.orderDetail.showId)
          const a = document.createElement('a')
          let href = ''
          if (ISANDROID) {
            href = `&redirect_ur=${encodeURIComponent(returnUrl)}`
          } else if (ISIOS) {
            href = `&redirect_url=${encodeURIComponent(returnUrl)}`
          } else {
            href = `&redirect_url=${this.getReturnUrl('isWxPay')}`
          }
          a.href = res.data + href
          a.id = 'weixinPay'
          window.localStorage.setItem('code', this.payOrderId)
          window.localStorage.setItem('codeUrl', returnUrl)
          window.localStorage.setItem('codeHref', href)
          document.body.appendChild(a)
          document.getElementById('weixinPay').click()
        })
      }
    },

    handleChange (val) {
      this.$nextTick(() => {
        this.num = parseInt(this.num)
        this.getExecRule(this.packageInfo.totalNum * this.num, this.packageInfo.price * this.num)
      })
    },
    useBalance () {
      const params = {}
      this.$ajax(this.$url.getAccountWalletAmount(), params, false).then(res => {
        this.myWallet = res.data.balance
        this.actions.push({ name: $t('余额支付'), method: this.getBalance })
      })
    },
    goOut () {
      this.$ajax(this.$url.logout(), {}).then(res => {
        window.location.href = `${this.$Dic.getDefaultURL().agentURL}?agentId=${sessionStorage.getItem('agentId')}`
      })
    },
    sure () {
      this.popupVisible = false
      this.submitLoading = true
      this.walletPay()
    },
    getBalance () {
      if (this.myWallet < this.returnSaleMoney(this.packageInfo.price)) {
        MessageBox.alert($t('对不起！您的账户余额不足。')).then(action => { })
      } else {
        this.popupVisible = true
        this.password = ''
      }
    },
    getReturnUrl (isWxPay) {
      const token = localStorage.getItem('token')
      const url = localStorage.getItem('returnUrl') || ''
      const isContainParams = url.indexOf('?') === -1
      // app - e签盾场景下支付成功后需要orderId查询订单状态
      let returnUrl = `${window.location.origin}/MyOrder/h5Result?ctype=${this.$route.query.ctype}&payOrderId=${this.payOrderId}&orderId=${this.orderId}`
      if (isWxPay) {
        // 微信支付需要encodeURIComponent
        // e签盾android/ios app内微信支付场景下的重定向地址在后面encode处理
        // 因为后面url变量有值时继续拼接参数导致returnUrl的值实际是两段encode字符串的拼接，重定向回来地址解码会有问题导致地址缺失，所以后面统一处理
        // 目前已知的其他场景跳转回来不受影响，可能存在未知场景所以暂时只判断修改e签盾场景
        if (this.isEqdAndroidApp || this.isEqdIosApp) {
          returnUrl = `${returnUrl}${isWxPay ? '&isWxPay=true' : ''}`
        } else {
          returnUrl = encodeURIComponent(`${returnUrl}${isWxPay ? '&isWxPay=true' : ''}`)
        }
      }
      if (token && token != 'undefined') {
        returnUrl = `${returnUrl}&token=${token}`
      }

      if (url) {
        returnUrl = `${returnUrl}&returnUrl=${encodeURIComponent(
          `${url}${isContainParams ? '?' : '&'}orderId=${this.orderId}`
        )}`
      }
      // e签盾android/ios app中微信支付场景需要对redirect_url encode处理，否则支付成功/失败后跳转回来重定向地址会丢失
      // 其他场景目前没有问题暂不处理
      if ((this.isEqdAndroidApp || this.isEqdIosApp) && isWxPay) {
        return encodeURIComponent(returnUrl)
      }
      return returnUrl
    },
    // 创建小程序支付单(支付宝、微信小程序)
    createAppletPay ({ thirdpartyKey, returnUrl, thirdPayMode, openId }) {
      // 传入三方key则优先从接口获取的数据中取三方用户信息（三方key有：ALI_PAY、DING_TALK、WE_CHAT、WECHAT_MINI_OPEN、WECHAT_OFFICIAL_ACCOUNT、DING_MIX等）
      // 目前只有支付宝小程序的三方用户id从接口信息获取，其他三方信息获取请各方对齐后再做改动
      const thirdpartyUserInfo =
        (thirdpartyKey &&
          this.userInfo &&
          this.userInfo.contacts &&
          this.userInfo.contacts.thirdparties &&
          this.userInfo.contacts.thirdparties.find(item => {
            return item.thirdpartyKey === thirdpartyKey
          })) ||
        {}
      const data = {
        openId: openId || thirdpartyUserInfo.thirdpartyUserId || '', // 支付宝/微信 三方用户Id
        thirdPayMode, // 支付方式：ALIPAY-支付宝;TENPAY-微信
        returnUrl, // 回跳地址
        client: this.$route.query.client, // 端标识：ALI_PAY_MINI：e签宝电子合同， ALI_PAY_MINI_BID：e签盾；其他...
        ouid: localStorage.getItem('ouid'),
        promoTag: '' // 优惠标识
      }
      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.appletPay(this.payOrderId), data)
          .then(res => {
            // 返回三方交易支付单号
            resolve(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 支付宝jsapi支付是否成功查询,和pc端逻辑保持一至不超时
    async queryAliJsapiPayStatus () {
      let pollTime = 0 // 轮询一分钟后终结
      this.clock = setInterval(() => {
        this.$ajax(this.$url.getPayOrderDetail(this.payOrderId)).then(res => {
          pollTime++
          if (res.data.status === 'PAY_SUCCESS') {
            window.my.postMessage({ orderId: this.orderId })
            // 支付成功
            window.location.href = this.getReturnUrl()
            clearInterval(this.clock)
            this.$reportBusiness('business_ali_jsapi_success', 'order_pay', {
              appId: this.$route.query.appid,
              ouid: this.userInfo.gid,
              orgId: this.userInfo.orgId,
              payOrderId: this.payOrderId,
              payStatus: res.data.status,
              stage: 'result'
            })
            // 非 PAY_AUDITING、PAY_PENDING状态停止轮询
          } else if (!(res.data.status === 'PAY_AUDITING' || res.data.status === 'PAY_PENDING')) {
            clearInterval(this.clock)
          }
          if (pollTime >= 60) {
            clearInterval(this.clock)
          }
        })
      }, 1000)
    },
    async aliPay () {
      // 带了ALI_PAY_MINI开头标识的，且是支付宝小程序内部的走jsapi支付
      if (this.isAliPay && this.isAliPayMini) {
        if (this.clock !== null) clearInterval(this.clock)
        // 给小程序发消息，e签宝电子合同小程序插件会判断发送消息中无type不处理消息，e签盾的插件页面需要orderId
        const tradeNo = await this.createAppletPay({
          thirdpartyKey: 'ALI_PAY',
          thirdPayMode: 'ALIPAY',
          returnUrl: this.getReturnUrl()
        })
        window.my.tradePay({
          // 调用统一收单交易创建接口（alipay.trade.create），获得返回字段支付宝交易号 trade_no
          tradeNO: tradeNo,
          success: res => {
            const { resultCode } = res
            try {
              this.$reportBusiness('business_ali_jsapi_start', 'tradePay', {
                appId: this.$route.query.appid,
                ouid: this.userInfo.gid,
                orgId: this.userInfo.orgId,
                payOrderId: this.payOrderId,
                code,
                reason: JSON.stringify(res)
              })
              tsignDataTrack.track('ali_jssdkPay_tradePay_success', { code: resultCode, reason: JSON.stringify(res) })
              this.reportSourceChannel('order_pay_success', this.orderDetail.showId)
            } catch (e) { }
            // 4000 订单处理失败, 6002 网络连接出错。
            if (resultCode === '4000' || resultCode === '6002') {
              this.$message.error($t('系统异常'))
              return
            }
            // 用户中途取消支付
            if (resultCode === '6001') return
            // 其他可能成功的情况 6004 处理结果未知（有可能已经成功），8000 正在处理中。支付结果未知（有可能已经支付成功），9000 订单处理成功(不能判定就是支付成功)
            // https://opendocs.alipay.com/mini/05xhsr?pathHash=d4709298
            this.queryAliJsapiPayStatus()
          },
          fail: res => {
            // 支付失败
            this.$message.error($t('支付失败，请重新尝试支付'))
            this.$reportBusiness('business_ali_jsapi_fail', 'tradePay', {
              appId: this.$route.query.appid,
              ouid: this.userInfo.gid,
              orgId: this.userInfo.orgId,
              payOrderId: this.payOrderId,
              reason: JSON.stringify(res)
            })
            tsignDataTrack.track('ali_jssdkPay_error', { reason: JSON.stringify(res) })
          }
        })
        return
      }
      // 支付宝小程序外支付宝支付
      this.$ajax(this.$url.thirdPartPay('aliwappay', this.payOrderId), { returnUrl: this.getReturnUrl() }).then(res => {
        const div = document.createElement('div')
        div.innerHTML = res.data // 此处form就是后台返回接收到的数据
        document.body.appendChild(div)

        // 支付宝内置浏览器 通过postMessage向招签宝发送orderId
        if (navigator.userAgent.indexOf('AliApp') > -1) {
          console.log(this.payOrderId)
          try {
            this.reportSourceChannel('order_pay_success', this.orderDetail.showId)
            my && my.postMessage({ orderId: this.orderId, tag: 'second' })
          } catch (err) {
            console.log(err)
          }
        }
        document.forms[0].submit()
      })
    },
    handleConfirm (val) {
      this.pickerValue = +val
    },
    openPicker () {
      if (this.disableTimeChange) return
      this.$refs.picker.open()
    },
    getCommodity () {
      this.$ajax(this.$url.getCommodity(this.$route.query.commodityId)).then(res => {
        // 当前没优惠活动，自动匹配优惠
        // if (!this.$route.query.condCode) {
        //   this.$ajax(this.$url.getPackages(), {
        //     productId: res.data.billingProductId
        //   }).then(res => {
        //     // 取出所有商品详情的折扣列表
        //     const allActiveDiscounts = (res.data.commodityDetailList || [])
        //       .flatMap(item => item.activeDiscountList || [])
        //     // 找到 discountPrice 最低的折扣项
        //     let minDiscount = null
        //     if (allActiveDiscounts.length > 0) {
        //       minDiscount = allActiveDiscounts.reduce((prev, curr) => (
        //         prev.discountPrice < curr.discountPrice ? prev : curr
        //       ))
        //     }
        //     // 取出最低价的 condCode，如果没有则为 null
        //     const minCondCode = minDiscount ? minDiscount.condCode : null
        //     if (minCondCode) {
        //       this.$router.replace({
        //         path: this.$route.path,
        //         query: {
        //           ...this.$route.query,
        //           condCode: minCondCode
        //         }
        //       })
        //       return
        //     }

        //   })
        // }

        this.commodityNo = res.data.commodityNo
        this.billingProductId = res.data.billingProductId
        this.productType = res.data.billingProduct.productType
        this.commodityName = res.data.commodityName
        this.saleType = res.data.saleType
        if (this.saleType == 1) {
          res.data.packages.forEach(element => {
            if (element.id == this.$route.query.menuId) {
              this.packageInfo = element
            }
          })
          this.getExecRule(this.packageInfo.totalNum, this.packageInfo.price)
        } else if (this.saleType == 2) {
          this.packageInfo = {
            commodityName: res.data.commodityName,
            price: this.$route.query.amount,
            id: res.data.billingRules[0].id
          }
          this.getExecRule(this.$route.query.amount, this.$route.query.amount)
        } else if (this.saleType == 3) {
          res.data.licenses.forEach(element => {
            if (element.id == this.$route.query.menuId) {
              this.packageInfo = element
            }
          })
          this.getExecRule(this.packageInfo.totalNum, this.packageInfo.price)
        }
        this.reportSourceChannel('to_creat_order')
      })
    },
    getExecRule (totalNum, price) {
      if (totalNum && price) {
        this.exeTotalNum = totalNum
        this.extPrice = price
      }
      const data = {
        price: price || this.extPrice,
        totalNum: totalNum || this.exeTotalNum,
        commodityNo: this.commodityNo,
        productId: this.billingProductId,
        showcaseNo: '',
        agentId: this.$route.query.agentId,
        gid: this.userInfo.gid,
        promoCode: this.couponsNumber,
        channelGid: this.$route.query.ditchID,
        condCode: this.$route.query.condCode
      }
      this.$ajax(this.$url.execRule(), data)
        .then(res => {
          // 无优惠信息时，重置订单数据
          if (res.data == null) {
            this.saleOff = ''
            this.activeNo = null
            this.discountType = ''
            this.discountAmount = ''
            this.discountPrice = ''
            this.discounted = 0
            this.realCouponsNumber = this.couponsNumber = ''
            this.isChangeStatus = false

            return
          }
          this.realCouponsNumber = this.couponsNumber
          // 优惠券
          this.isChangeStatus = this.realCouponsNumber !== ''

          this.activeNo = res.data.activeNo
          if (res.data.discountType == 0) {
            this.saleOff = $t('优惠{slot1}元', { slot1: res.data.discountAmount })
          } else if (res.data.discountType == 1) {
            this.saleOff = $t('折扣{slot1}%', { slot1: res.data.discountAmount * 100 })
          }
          this.discountType = res.data.discountType
          this.discountAmount = res.data.discountAmount
          this.discountPrice = res.data.discountPrice
          this.discounted = res.data.discounted
        })
        .catch(() => {
          this.saleOff = ''
          this.activeNo = null
          this.discountType = ''
          this.discountAmount = ''
          this.discountPrice = ''
          this.discounted = 0
          this.realCouponsNumber = this.couponsNumber = ''
          this.isChangeStatus = false
        })
    },
    returnSaleMoney (value) {
      let money = value
      money *= this.num
      if (this.saleOff) {
        if (this.discountType == 1) {
          return (money * this.discountAmount).toFixed(2)
        }

        return (money - this.discountAmount).toFixed(2)
      }

      return money
    },
    getParams () {
      const data = {
        businessId: this.$route.query.businessId,
        _latest_tsign_source_type: this.$route.query.tsign_source_type || this.tsignData._latest_tsign_source_type,
        _latest_tsign_source_detail:
          this.$route.query.tsign_source_detail || this.tsignData._latest_tsign_source_detail,
        platformType: 'H5',
        agentId: this.$route.query.agentId,
        channelGid: this.$route.query.ditchID,
        activeNo: this.activeNo,
        accountingInfo: {
          totalAmount: this.packageInfo.price //  下单总额
        },
        commodities: [
          {
            num: this.num,
            commodityId: this.$route.query.commodityId, //  商品ID
            specification: {
              id: parseInt(this.$route.query.menuId) || this.packageInfo.id,
              idType: this.saleType == 1 ? 'plan' : this.saleType == 2 ? 'rule' : 'license',
              isContinuedValidityTerm: false
            }
          }
        ],

        invoice: {
          /* i18n-ignore */
          type: '线上', //  线下
          invoiceTitleName: null, //  发票抬头
          invoiceType: null, //  发票类型:  1-增值税普通发票;  2-增值税专用发票
          invoiceForm: null, //  开票形式:  1-电子;  2-纸质
          fee: null, //  邮费
          identifyNumber: null, //  纳税人识别号
          bank: null, //  开户银行
          bankAccount: null, //  银行账号
          invoiceAddress: null, //  开票地址
          invoiceTelephone: null, //  开票电话
          invoiceRemark: null, //  开票备注
          receiver: null, //  收件人
          receiveAddress: null, //  收件地址
          receivePhone: null, //  收件电话
          expressPayMethod: null //  快递支付方式:  1-寄付;  2-到付
        },
        needInvoice: false,
        validDateTime: this.pickerValue,
        sourceChannel: this.sourceChannel,
        settleContext: {
          cooperatorId: this.$route.query.cooperatorId || '',
          cooperatorMode: this.$route.query.cooperatorMode || '',
          projectCode: this.$route.query.projectCode || ''
        },
        extendedParams: {
          promotionSource: this.$route.query.promotionSource || '', // 推广来源
          appId: this.$route.query.appId || ''
        }
      }
      const { licenseId = '' } = this.$route.query
      if (licenseId) data.licenseId = licenseId
      if (this.saleType == 1 || this.saleType == 3) {
        data.commodities[0].specification.realVolumn = this.packageInfo.totalNum
      } else {
        data.commodities[0].specification.realAmount = this.packageInfo.price
      }
      const { condCode = '' } = this.$route.query
      if (condCode) data.condCode = condCode

      return data
    },
    getOrderDetail (orderId) {
      const oid = this.userInfo.orgId || localStorage.getItem('ouid')
      if (!oid) return
      this.$ajax(this.$url.getOrderDetailByOrderId(orderId, oid)).then(res => {
        this.orderDetail = res.data
        this.reportSourceChannel('to_pay_order', this.orderDetail.showId)
      })
    },
    async submit () {
      if (!this.checked) {
        return false
      }
      // ALIPAY_MINI("ALI_PAY_MINI", "e签宝支付宝小程序"),
      // WECHAT("WE_CHAT", "e签宝微信小程序"),
      // APP_IOS("APP_IOS", "IOS标准签app"),
      // APP_ANDROID("APP_ANDROID", "Android标准签app"),
      const data = {
        commodityNo: this.commodityNo,
        price: this.extPrice,
        totalNum: this.exeTotalNum,
        productId: this.billingProductId,
        agentId: this.$route.query.agentId,
        gid: this.userInfo.gid,
        promoCode: this.couponsNumber,
        channelGid: this.$route.query.ditchID,
        clientChannel: this.isAndroidApp
          ? 1
          : this.isIosApp
            ? 2
            : this.isAliPay
              ? 3
              : this.$route.query.client === 'WE_CHAT' ||
                this.$route.query.client === 'WE_CHAT_BOSS' ||
                this.$route.query.client === 'WE_CHAT_ZQB'
                ? 4
                : '',
        condCode: this.$route.query.condCode
      }
      this.submitLoading = true
      const res = await this.$ajax(this.$url.execRule(), data)
      if ((res.data == null && this.activeNo == null) || (res.data && res.data.activeNo == this.activeNo)) {
      } else {
        MessageBox.alert($t('产品价格发生变更，请点击确定，页面将自动刷新')).then(action => {
          this.$router.go(0)
        })

        return false
      }
      this.$ajax(this.$url.getBillIds(), this.getParams())
        .then(res => {
          this.orderId = res.data.orderIds[0]
          if (this.orderId === null) {
            this.$message.error($t('生成订单失败'))

            return
          }
          this.getPayOrderId(this.orderId)
          this.getOrderDetail(this.orderId)
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    walletPay () {
      const params = {}
      params.password = MD5(this.password)
      this.$ajax(this.$url.walletPay(this.payOrderId), params)
        .then(res => {
          this.reportSourceChannel('order_pay_success', this.orderDetail.showId)
          this.$router.push({
            path: `/MyOrder/h5Result`,
            query: {
              orderId: this.orderId || ''
            }
          })
        })
        .finally(() => {
          this.submitLoading = false
        })
    },

    // 换取payOrderId
    getPayOrderId (orderId) {
      const params = {
        fee: 0
      }
      params.operation = 'PAY_FOR_ORDER'
      params.objects = [
        {
          orderId,
          price: this.returnSaleMoney(this.packageInfo.price)
        }
      ]

      this.$ajax(this.$url.getPayorderId(), params).then(res => {
        this.payOrderId = res.data
        // 如果只有一种支付方式，直接拉起支付
        if (this.actions.length === 1) {
          return this.actions[0].method()
        }
        this.sheetVisible = true
      })
    },
    viewCert () {
      window.location.href = 'https://asset.esign.cn/template/agreement.html'
    }
  },
  created () {
    tsignDataTrack.track('h5Buy')
    if (this.$route.query.tsign_source_type === 'DITCH' && this.$route.query.ditchID) {
      this.getPromoInfo(this.$route.query.ditchID)
    } else {
      this.getCommodity()
    }
  },
  async mounted () {
    this.isAliPayMini = await detectAliMini()
    if (this.$route.query.banNumContral && this.$route.query.banNumContral !== 'undefined') {
      this.banNumContral = true
    }
    // 解决ios微信浏览器 返回刷新导致es-input-number 数值不显示的问题
    var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (navigator.userAgent.indexOf('MicroMessenger') > 0 && isiOS) {
      window.addEventListener('pageshow', () => {
        if (this.isPageHide) {
          this.inputkey++
        }
      })
      window.addEventListener('pagehide', () => {
        this.isPageHide = true
      })
    }

    console.log(!['WE_CHAT', 'ALI_PAY_MINI'].includes(this.$route.query.client))
    // 余额屏蔽微信相关端，新增屏蔽e签盾安卓和e签盾ios端
    if (
      this.userInfo.realName &&
      this.userInfo.isAdmin &&
      ![
        'WE_CHAT',
        'WE_CHAT_BOSS',
        'WE_CHAT_ZQB',
        'EQD_APP_IOS',
        'EQD_APP_ANDROID',
        'EQB_APP_IOS',
        'EQB_APP_ANDROID'
      ].includes(this.$route.query.client) &&
      !this.isAliPay
    ) {
      this.useBalance()
    }
    if (
      this.$route.query.client != 'WE_CHAT' &&
      this.$route.query.client != 'WE_CHAT_BOSS' &&
      this.$route.query.client != 'WE_CHAT_ZQB'
    ) {
      // 小程序中不显示支付宝支付
      this.actions.push({ name: $t('支付宝支付'), method: this.aliPay })
    }
    if (this.showWeChatPay) {
      // const { client } = this.$route.query
      // if (client === 'WE_CHAT' || client === 'WE_CHAT_BOSS' || client === 'WE_CHAT_ZQB') {
      this.actions.push({ name: $t('微信支付'), method: this.weixinPay })
      // }
    }
    // 判断是否在微信内置浏览器 并且未获取授权code
    if (
      navigator.userAgent.indexOf('MicroMessenger') > 0 &&
      sessionStorage.getItem('hasCode') !== 'true' &&
      this.$route.query.client === 'WE_CHAT_WEB'
    ) {
      sessionStorage.setItem('hasCode', 'true')
      // 静默跳转获取微信授权code  需要通过code换取openid
      window.location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$route.query.appid || 'wxc2dde4e5f9b176cf'
        }&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_base`
      )
    }
    // replace后判断是否获取授权code 存在code并且没有openid
    if (
      this.$route.query.code &&
      !this.$route.query.openId &&
      !sessionStorage.getItem('openId') &&
      this.$route.query.client === 'WE_CHAT_WEB'
    ) {
      // 换取openid
      this.$ajax(this.$url.getOpenId(), { authCode: this.$route.query.code, clientType: 'E_SERVICE' }).then(res => {
        this.openId = res.data.openId
        sessionStorage.setItem('hasCode', '')
        sessionStorage.setItem('openId', res.data.openId)
        if (this.openId) {
          sessionStorage.setItem('confirmUrl', window.location.href + `&openId=${this.openId}`)
        }
      })
    } else if (this.$route.query.openId || sessionStorage.getItem('openId')) {
      this.openId = this.$route.query.openId || sessionStorage.getItem('openId')
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background: #fff;
  margin-bottom: 10px;
}

.confirm {
  height: 100%;
  background: #f6f6f6;
}

.confirm-agree {
  position: fixed;
  bottom: 78px;
  width: 100%;
  text-align: center;
  background: #fff;
  padding-top: 5px;
}

.confirm-agree-btn {
  color: #108ee9;
}

.info {
  height: 120px;
  background: #fff;
  padding: 20px;
  display: flex;
}

.info {
  >div {
    flex: 1;
    padding-left: 10px;

    >p:first-child {
      display: flex;
      color: #333;
      font-size: 16px;
      justify-content: space-between;
    }

    >p:last-child {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
  }

  img {
    width: 70px;
  }
}

.first-child {
  color: #ff943e;
  background: #fff2e7;
  padding: 0 5px;
  font-size: 14px;
}

.last-child {
  color: #0975e0;
  font-size: 14px;
}

.diacount {
  padding: 0 20px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  height: 70px;
  line-height: 70px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  color: #000000;
  font-size: 16px;
}

.time {
  padding: 0 20px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  height: 70px;
  line-height: 70px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  color: #000000;
  font-size: 16px;

  .disabledText {
    color: #ccc;
  }
}

.tip {
  color: #cccccc;
  color: red;
  font-size: 14px;
  padding: 14px;
  padding-bottom: 140px;
}

.footer {
  font-size: 18px;
  position: fixed;
  bottom: 0;
  padding: 15px;
  width: 100%;
  background: #fff;

  >div {
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background: linear-gradient(226deg, rgba(230, 77, 46, 1) 0%, rgba(230, 0, 0, 1) 100%);
  }

  .button {
    border: none;
    width: 100%;
  }

  .disabled {
    background: #999999 !important;
  }
}

.common-price,
.discount-price,
.ticket {
  padding: 0 20px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  height: 70px;
  line-height: 70px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  color: #000000;
  font-size: 16px;

  span {
    font-size: 12px;
    font-weight: 400;
    color: #e63740;
  }

  i {
    margin-left: 5px;
    color: #e63740;
    vertical-align: middle;
    margin-top: -2px;
  }
}

/deep/ .mint-popup-bottom {
  width: 100%;
}

/deep/ .mint-msgbox-wrapper {
  .mint-msgbox-message {
    color: red;
  }
}

.popup-head {
  height: 45px;
  line-height: 45px;
  font-size: 18px;
  text-align: center;
  border-bottom: 1px solid #dedee2ff;
}

.popup-body {
  padding: 30px 15px;
  display: flex;
}

.es-icon-arrow-left {
  position: absolute;
  left: 10px;
  top: 13px;
  font-size: 18px;
}

.el-icon-circle-plus {
  vertical-align: middle;
  cursor: pointer;
  color: rgb(17, 170, 102);
  font-size: 18px;
}
</style>
